// src/components/MarketplaceSkeleton.jsx
import React from "react";
import "./MarketplaceSkeleton.css";

export default function MarketplaceSkeleton({ spinnerSrc }) {
  return (
    <div className="marketplace-skeleton-wrapper">
      
      {/* 🔥 Spinner Overlay */}
      <div className="ms-spinner-overlay">
        <img
          src={spinnerSrc}
          alt="Loading"
          className="ms-spinner-logo"
        />
      </div>

      {/* Skeleton content */}
      <div className="marketplace-skeleton">
        <section className="ms-section">
          <div className="ms-header">
            <div className="ms-header__left">
              <div className="ms-shimmer ms-line ms-line--sectionTitle" />
              <div className="ms-shimmer ms-pill ms-pill--featured" />
            </div>
          </div>

          <div className="ms-carousel">
            <div className="ms-card"><div className="ms-shimmer ms-card__image" /></div>
            <div className="ms-card"><div className="ms-shimmer ms-card__image" /></div>
            <div className="ms-card"><div className="ms-shimmer ms-card__image" /></div>
          </div>
        </section>

        <section className="ms-section">
          <div className="ms-shimmer ms-line ms-line--sectionTitle" />

          <div className="ms-grid">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="ms-card">
                <div className="ms-shimmer ms-card__image" />
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}